import { Component, computed, input, linkedSignal, output } from '@angular/core';
import { IMultiProductCard, TextNodeType } from '@mwe/models';
import { isArrayWithOneItem } from '@mwe/utils';
import { ISliderResponse, ProductCardSliderComponent } from '../product-card-slider/product-card-slider.component';
import { NgClass } from '@angular/common';
import { MultiProductCardComponent } from './multi-product-card.component';
import { CardSelectableComponent } from '../../cards/card-selectable/card-selectable.component';
import { CorrelatedCompanyReferencePipe } from '@mwe/ui/pipes';
import { ProductIconsComponent } from '../../product-icons/product-icons.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-multi-product-card-container',
  templateUrl: './multi-product-card-container.component.html',
  imports: [
    MultiProductCardComponent,
    NgClass,
    ProductCardSliderComponent,
    CardSelectableComponent,
    CorrelatedCompanyReferencePipe,
    ProductIconsComponent,
    TranslatePipe,
  ],
})
export class MultiProductCardContainerComponent {
  isSliderVisible = input(true);
  multiProductCards = input<IMultiProductCard[]>([]);
  isInvalid = input(false);
  isDisabled = input(false);
  showCompanyReference = input(false);
  showSummarizedCompanyReference = input(false);
  showAccountNumber = input(false);
  showCustomerNumber = input(false);
  hasMousePointerStyle = input(false);
  useSelectableCards = input(false);
  headlineNodeType = input<TextNodeType>('h5');

  readonly handleSelectedIds = output<string[]>();
  readonly cardClicked = output<IMultiProductCard>();

  showSlider = computed(() => {
    if (isArrayWithOneItem(this.multiProductCards())) {
      return false;
    }

    return this.isSliderVisible();
  });
  isOnlyOneVk = computed(() => this.isDisabled() || !this.showSlider());
  selectedIds = linkedSignal(() => this.multiProductCards().map(mpc => mpc.id));

  handleSliderResponse(response: ISliderResponse): void {
    this.selectedIds.set(
      response.checked ? [...this.selectedIds(), response.id] : this.selectedIds().filter(accountNr => accountNr !== response.id),
    );
    this.handleSelectedIds.emit(this.selectedIds());
  }
}
